// weitzman-quick-add.js
// Delegated "Add to Cart" handler for [data-quick-add] buttons (collection
// grid cards, PDP recommendations, recently-viewed rail). Loaded once per
// page by snippets/weitzman-quick-add.liquid; guards itself against being
// wired twice when more than one section that needs it (product, collection,
// recently-viewed) is present.
(function () {
  if (window.__wtzQuickAddWired) return;
  window.__wtzQuickAddWired = true;
  const config = window.__wtzQuickAddConfig || {};
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled || !window.WTZ || !window.WTZ.addToCart) return;
    e.preventDefault();
    const originalLabel = btn.textContent;
    btn.disabled = true;
    /* WTZ.addToCart (weitzman-cart.js) posts, announces the add and shows
       the confirmation toast; this only owns the button and its failure copy. */
    window.WTZ.addToCart({ id: btn.dataset.variantId, quantity: 1 })
      .catch(function (err) {
        const msg = err.description !== undefined
          ? (config.unavailableLabel || 'Unavailable')
          : (config.addFailedLabel || 'Could not add. Try again');
        window.WTZ.toast(msg, { type: 'error' });
      })
      .then(function () {
        btn.textContent = originalLabel;
        btn.disabled = false;
      });
  });
})();
